import React, { ReactElement } from "react";
import classNames from "classnames";
import styles from "./Button.module.css";

type ButtonV2Variant = "primary" | "secondary" | "blurred" | "lightBlue";

type ButtonV2Props = {
  title: string;
  onPress: () => void;
  variant?: ButtonV2Variant;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  /** A glyph from `ui-kit/icons`. Inherits the button's colour. */
  icon?: ReactElement;
  iconPosition?: "start" | "end";
};

export const ButtonV2 = ({
  title,
  onPress,
  variant = "primary",
  className,
  disabled = false,
  loading = false,
  icon,
  iconPosition = "start",
}: ButtonV2Props) => {
  const iconElement = icon ? <span className={styles.icon}>{icon}</span> : null;

  return (
    <button
      className={classNames(styles.button, styles[variant], className)}
      onClick={() => !loading && onPress()}
      disabled={disabled || loading}
    >
      {icon && iconPosition === "start" && iconElement}
      <span className={styles.title}>{title}</span>
      {icon && iconPosition === "end" && iconElement}
    </button>
  );
};
